import axios from 'axios';

export function setContentFromPropState(props, state) {
  return Object.keys(state).reduce((body, key) => {
    if (state[key].length) {
      return `${body} \n ${key}: ${state[key]}`;
    }
    return `${body}`;
  }, `form: ${props.title}`);
}

export function postData(data) {
  return axios.post(
    'https://wt-139739a316b9b05b2ef2d61c5ed80be7-0.sandbox.auth0-extend.com/new-partner',
    { data }
  );
}

export const delay = ms => new Promise(resolve => setTimeout(resolve, ms));

export default {
  setContentFromPropState,
  postData,
  delay
};



// WEBPACK FOOTER //
// ./src/pages/partners/components/Form/utils.js